var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Proximo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_746_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_358_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M60,33c-0.26025,0-0.52002-0.11035-0.70996-0.29004C59.10986,32.51953,59,32.26953,59,32 c0-0.27051,0.10986-0.52051,0.29004-0.70996c0.37988-0.37012,1.0498-0.37012,1.41992,0C60.88965,31.47949,61,31.74023,61,32 c0,0.26953-0.11035,0.51953-0.29004,0.70996C60.52002,32.88965,60.27002,33,60,33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_357_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M63,33c-0.27002,0-0.52002-0.11035-0.70996-0.29004C62.10986,32.51953,62,32.26953,62,32 c0-0.27051,0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C63.88965,31.47949,64,31.74023,64,32 c0,0.26953-0.11035,0.51953-0.29004,0.70996C63.52002,32.88965,63.27002,33,63,33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_619_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1128_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#54FEBD",
    cx: 28,
    cy: 32,
    rx: 11.96,
    ry: 25
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_296_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,5c-0.26025,0-0.52002-0.11035-0.70996-0.29004C31.10986,4.51953,31,4.25977,31,4 c0-0.27051,0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.03955-0.37012,1.41992,0C32.88965,3.47949,33,3.74023,33,4 s-0.11035,0.51953-0.29004,0.70996C32.52002,4.88965,32.25977,5,32,5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_298_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,2c-0.26025,0-0.52002-0.11035-0.70996-0.29004C31.10986,1.51953,31,1.25977,31,1 s0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C32.88965,0.47949,33,0.74023,33,1 s-0.11035,0.51953-0.29004,0.70996C32.52002,1.88965,32.25977,2,32,2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_230_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,58C17.66357,58,6,46.33691,6,32S17.66357,6,32,6s26,11.66309,26,26S46.33643,58,32,58z M32,8 C18.7666,8,8,18.7666,8,32s10.7666,24,24,24s24-10.7666,24-24S45.2334,8,32,8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_295_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,58c-7.26709,0-12.95996-11.4209-12.95996-26S24.73291,6,32,6s12.95996,11.4209,12.95996,26 S39.26709,58,32,58z M32,8c-5.94092,0-10.95996,10.99023-10.95996,24S26.05908,56,32,56s10.95996-10.99023,10.95996-24 S37.94092,8,32,8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_297_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M57,33H7c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h50c0.55225,0,1,0.44727,1,1S57.55225,33,57,33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_327_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M54.91992,23H9.08008c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h45.83984c0.55225,0,1,0.44727,1,1 S55.47217,23,54.91992,23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_328_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M47,13H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h30c0.55225,0,1,0.44727,1,1S47.55225,13,47,13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_321_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M54.91992,43H9.08008c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h45.83984c0.55225,0,1,0.44727,1,1 S55.47217,43,54.91992,43z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_319_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M47,53H17c-0.55225,0-1-0.44727-1-1s0.44775-1,1-1h30c0.55225,0,1,0.44727,1,1S47.55225,53,47,53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_294_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,58c-0.55225,0-1-0.44727-1-1V7c0-0.55273,0.44775-1,1-1s1,0.44727,1,1v50 C33,57.55273,32.55225,58,32,58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_370_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M50.38477,11.78711c-0.25586,0-0.51172-0.09766-0.70703-0.29297 c-0.39063-0.39063-0.39063-1.02344,0-1.41406l4.12109-4.12207c0.39063-0.39063,1.02344-0.39063,1.41406,0 s0.39063,1.02344,0,1.41406l-4.12109,4.12207C50.89648,11.68945,50.64063,11.78711,50.38477,11.78711z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_369_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M53.92041,15.32227c-0.25586,0-0.51172-0.09766-0.70703-0.29297 c-0.39063-0.39063-0.39063-1.02344,0-1.41406l2.12109-2.12109c0.39063-0.39063,1.02344-0.39063,1.41406,0 s0.39063,1.02344,0,1.41406l-2.12109,2.12109C54.43213,15.22461,54.17627,15.32227,53.92041,15.32227z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_368_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M8.66553,53.50586c-0.25586,0-0.51172-0.09766-0.70703-0.29297 c-0.39063-0.39063-0.39063-1.02344,0-1.41406l2.12109-2.12109c0.39063-0.39063,1.02344-0.39063,1.41406,0 s0.39063,1.02344,0,1.41406l-2.12109,2.12109C9.17725,53.4082,8.92139,53.50586,8.66553,53.50586z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_367_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M10.20117,59.04199c-0.25586,0-0.51172-0.09766-0.70703-0.29297 c-0.39063-0.39063-0.39063-1.02344,0-1.41406l4.12109-4.12207c0.39063-0.39063,1.02344-0.39063,1.41406,0 s0.39063,1.02344,0,1.41406l-4.12109,4.12207C10.71289,58.94434,10.45703,59.04199,10.20117,59.04199z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_364_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M55.68799,53.15234c-0.25586,0-0.51172-0.09766-0.70703-0.29297l-2.12109-2.12109 c-0.39063-0.39063-0.39063-1.02344,0-1.41406s1.02344-0.39063,1.41406,0l2.12109,2.12109 c0.39063,0.39063,0.39063,1.02344,0,1.41406C56.19971,53.05469,55.94385,53.15234,55.68799,53.15234z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_363_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M54.15234,58.68848c-0.25586,0-0.51172-0.09766-0.70703-0.29297l-4.12109-4.12207 c-0.39063-0.39063-0.39063-1.02344,0-1.41406s1.02344-0.39063,1.41406,0l4.12109,4.12207 c0.39063,0.39063,0.39063,1.02344,0,1.41406C54.66406,58.59082,54.4082,58.68848,54.15234,58.68848z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_362_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M13.96875,11.43359c-0.25586,0-0.51172-0.09766-0.70703-0.29297L9.14063,7.01855 C8.75,6.62793,8.75,5.99512,9.14063,5.60449s1.02344-0.39063,1.41406,0l4.12109,4.12207 c0.39063,0.39063,0.39063,1.02344,0,1.41406C14.48047,11.33594,14.22461,11.43359,13.96875,11.43359z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_361_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M10.43311,14.96875c-0.25586,0-0.51172-0.09766-0.70703-0.29297l-2.12109-2.12109 c-0.39063-0.39063-0.39063-1.02344,0-1.41406s1.02344-0.39063,1.41406,0l2.12109,2.12109 c0.39063,0.39063,0.39063,1.02344,0,1.41406C10.94482,14.87109,10.68896,14.96875,10.43311,14.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_330_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,64c-0.26025,0-0.52002-0.11035-0.70996-0.29004C31.10986,63.51953,31,63.25977,31,63 c0-0.27051,0.10986-0.52051,0.29004-0.70996c0.36963-0.37012,1.0498-0.37012,1.41992,0C32.88965,62.47949,33,62.74023,33,63 s-0.11035,0.51953-0.29004,0.70996C32.52002,63.88965,32.25977,64,32,64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_329_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M32,61c-0.26025,0-0.52002-0.11035-0.70996-0.29004C31.10986,60.51953,31,60.25977,31,60 c0-0.27051,0.10986-0.52051,0.2998-0.70996c0.35986-0.37012,1.04004-0.37012,1.41016,0C32.88965,59.47949,33,59.72949,33,60 c0,0.25977-0.11035,0.51953-0.29004,0.70996C32.52002,60.88965,32.25977,61,32,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_355_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M1,33c-0.27002,0-0.53027-0.11035-0.70996-0.2998C0.10986,32.51953,0,32.26953,0,32 c0-0.27051,0.10986-0.52051,0.29004-0.70996c0.36963-0.36035,1.0498-0.37012,1.41992,0C1.88965,31.47949,2,31.74023,2,32 c0,0.26953-0.11035,0.51953-0.29004,0.70996C1.52002,32.88965,1.27002,33,1,33z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_354_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1B4C",
    d: "M4,33c-0.27002,0-0.52002-0.11035-0.70996-0.2998C3.10986,32.51953,3,32.26953,3,32 c0-0.27051,0.10986-0.52051,0.29004-0.70996c0.36963-0.36035,1.0498-0.37012,1.41992,0C4.88965,31.47949,5,31.74023,5,32 c0,0.26953-0.11035,0.51953-0.29004,0.70996C4.52002,32.88965,4.27002,33,4,33z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.fd7c0b768ec863ca8e5dd00315f3cb90.svg";
export { ForwardRef as ReactComponent };